export function removeCartEmptyStateFromHeader() {
  const cartIconPointElements = document.querySelectorAll('.add-point-to-cart')

  cartIconPointElements.forEach(cartIconPointElement => {
    cartIconPointElement?.classList.remove('d-none')
  })
}
